import React from 'react';
import SecurityBadges from './SecurityBadges';
import DebtSummary from './DebtSummary';
import PaymentMethods from './PaymentMethods';
import ProcessSteps from './ProcessSteps';
import PaymentButton from './PaymentButton';
import ContactOptions from './ContactOptions';

const SecurePaymentInterface = ({ importeDeuda, divisa, formatAmount, urlPagoPropiaCliente, id }) => {
  return (
    <div className='max-w-3xl mx-auto px-4 py-8'>
      {/* Security Badges */}
      <SecurityBadges />

      {/* Main Content */}
      <div className='bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden'>
        {/* Debt Summary */}
        <DebtSummary importeDeuda={importeDeuda} divisa={divisa} formatAmount={formatAmount} />

        {/* Payment Methods Section */}
        <PaymentMethods />

        {/* Process Steps */}
        <ProcessSteps />

        {/* Payment Button Section */}
        <PaymentButton urlPagoPropiaCliente={urlPagoPropiaCliente} />
      </div>

      {/* Contact Options */}
      <ContactOptions id={id} />
    </div>
  );
};

export default SecurePaymentInterface;
